import React from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { getDefaultLaunchDarklyUser } from '../core/providers/launch-darkly';
import { getCurrentUser, getCurrentUserFlagDetails, getUserBuckets } from '../utils/user';

/**
 * Setup launch darkly - ensuring its set whenever the client changes
 */
export const useLaunchDarklyInit = () => {
  const ldClient = useLDClient();

  React.useEffect(() => {
    if (!ldClient) {
      return;
    }

    const initialiseLaunchDarkly = async () => {
      const user = await getCurrentUser();
      const currentUserFlagDetails = await getCurrentUserFlagDetails(user);
      const bucketInfo = await getUserBuckets(user);

      ldClient.identify({ ...currentUserFlagDetails, custom: { ...bucketInfo } });
    };

    initialiseLaunchDarkly();

    return function cleanup() {
      const resetLDUser = async () => {
        const defaultUser = await getDefaultLaunchDarklyUser();
        ldClient.identify(defaultUser);
      };

      // on unmount log out of launch darkly
      resetLDUser();
    };
  }, [ldClient]);
};
